var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HowToOrder"},[_c('h2',[_vm._v("Kaip užsakyti dalį nutolusios saulės elektrinės?")]),_c('IconColumns',{attrs:{"classes":_vm.classes,"data":_vm.steps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }